export default __webpack_public_path__ + "static/staff-locker-rooms-dc17ba6513112a98f71d3ec9ae0104bf.jpg";